import { render, staticRenderFns } from "./Deny.vue?vue&type=template&id=d318a106&scoped=true"
var script = {}
import style0 from "./Deny.vue?vue&type=style&index=0&id=d318a106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d318a106",
  null
  
)

export default component.exports